/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useEffect } from "react";
import styled from "@emotion/styled";
import { connect } from "react-redux";
import BackgroundImage from "./3-utils/BackgroundImage";
import Prism from "prismjs";
import CodePanel from "./3-utils/CodePanel";
import CodeSlideshow from "./3-utils/CodeSlideshow";

function ArticlePage({
  title,
  content,
  backgroundImage,
  datePosted,
  codePages
}) {
  return (
    <Container>
      <Header src={backgroundImage.fields.file.url}>{title}</Header>
      <Content dangerouslySetInnerHTML={{ __html: content }} />
      <CodeSlideshow codePages={codePages}/>
    </Container>
  );
}


const Header = styled(BackgroundImage)`
  padding: 2em 0;

  #img {
    top: 20px;
    right: 20px;
  }

  #content {
    color: white;
    padding: 1em 0;
    font-size: 70px;
    font-weight: bold;
    @media (max-width: 600px) {
      font-size: 40px;
    }
  }
`;

const Content = styled.p`
  font-size: 20px;
  padding: 1em 4em 1em 0;
  line-height: 1.4em;
  color: #c2c2c2;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: auto;
  overflow: hidden;
  padding-bottom: 2em;
  @media (max-width: 600px) {
    margin: 1em;
  }
`;

const select = ({ blogs, route }) => {
  let blog = blogs.find(blog => route.articleId === blog.sys.id);
  return {
    ...blog.fields
  };
};

export default connect(select)(ArticlePage);
